<template>
  <v-container>
    <v-form ref="form" v-model="valid" @submit.prevent="send">
      <v-card class="mt-4 px-4 py-2">
        <v-card-title class="mb-5">
          <v-btn class="teal lighten-1 mr-3" dark fab text>
            <v-icon>mdi-email-plus</v-icon>
          </v-btn>
          <span>Contact Me</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            class="mb-5"
            prepend-icon="mdi-email"
            v-model="form.email"
            :rules="rules.emailRule"
            label="Email"
            placeholder="Enter an email address"
            outlined
          ></v-text-field>

          <v-text-field
            class="mb-5"
            prepend-icon="mdi-account"
            v-model="form.name"
            :rules="rules.nameRule"
            label="Name"
            placeholder="Enter an your name"
            outlined
          ></v-text-field>

          <v-textarea
            prepend-icon="mdi-message"
            v-model="form.message"
            :rules="rules.messageRule"
            label="Message"
            placeholder="Enter an your message"
            outlined
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="submit" large color="teal lighten-1" dark>Send Message</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      valid: false,
      form: {
        name: '',
        email: '',
        message: ''
      },
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      rules: {
        emailRule: [v => !!v || "Email Address is required.", v => this.emailReg.test(v) || 'Invalid Email Address'],
        nameRule: [v => !!v || "Name is required"],
        messageRule: [v => !!v || "Message is required"]

      }
    }
  },
  methods: {
    send() {
      if (this.$refs.form.validate()) {
        this.$refs.form.reset()
        this.storeMessage("Message sent successfully.")
      }
    },
    ...mapActions({
      storeMessage: 'snackbar/storeMessage'
    })
  }
}
</script>